import React, { useState } from 'react';
import { WordsImageWrapper } from '../Styled';
import { ExemplarImage } from '../Image';
import { IWordState } from '../../contexts/styledWordContext';
import { EditImageTool } from '../EditTool/EditImageTool';
import { ImageDimensions, ImageSide } from '../../types';
import { EyeIcon } from '../../assets/icons/ImageEditTool';
import { StyledHiddenBlockWrapper } from '../Styled/StyledWrappers';
import { DEFAULT_IMAGE_DIMENSIONS } from '../../constants/exemplar';
interface IWordsImage {
  editMode: boolean;
  y: number;
  x: number;
  height: number;
  width: number;
  url: string;
  isHidden: boolean;
  id: number;
  default_uuid?: string;
  uuid: string;
  imageKey: string;
  handleClick: (id: number) => void;
  styledWordState: IWordState;
  uploadImage: (
    id: string,
    default_uuid: string | undefined,
    sectionId: string,
    imageDimensions: ImageDimensions,
    side?: ImageSide,
    key?: string
  ) => void;
}

export const WordsImage: React.FC<IWordsImage> = (props): JSX.Element => {
  const {
    x,
    y,
    width,
    url,
    isHidden,
    height,
    id,
    uuid,
    default_uuid,
    imageKey,
    handleClick,
    styledWordState,
    uploadImage,
    editMode,
  } = props;

  const [defaultImageDimensions, setDefaultImageDimensions] = useState<ImageDimensions>(DEFAULT_IMAGE_DIMENSIONS);

  const isNotUploadImageLabel = (ariaLabel: string | null) => ariaLabel !== 'Upload image';

  const handleImageClick = (e: React.MouseEvent) => {
    const ariaLabel = (e.target as Element).getAttribute('aria-label');
    if (isNotUploadImageLabel(ariaLabel)) handleClick(id);
  };

  const handleImageKeyDown = (event: React.KeyboardEvent) => {
    const { key } = event;
    const ariaLabel = (event.target as Element).getAttribute('aria-label');

    if (key == 'Enter' || key === ' ') {
      event.preventDefault();
      if (isNotUploadImageLabel(ariaLabel)) handleClick(id);
    }
  };

  const withText = (926 * width) / 100 >= 140 && (629 * height) / 100 >= 87;

  return (
    <WordsImageWrapper
      data-testid={isHidden ? 'words-images-hidden' : 'words-images-revealed'}
      aria-label="Words page image"
      tabIndex={0}
      onKeyDown={handleImageKeyDown}
      isHidden={isHidden}
      onClick={handleImageClick}
      width={width}
      top={y}
      left={x}
      height={height}
    >
      {isHidden && styledWordState.imageTool.isVisible && (
        <StyledHiddenBlockWrapper withText={withText}>
          <EyeIcon />
          {withText && <span>Click here to reveal and edit this image</span>}
        </StyledHiddenBlockWrapper>
      )}
      {!isHidden && (
        <ExemplarImage
          isVisible={!isHidden}
          src={url}
          width={100}
          height={100}
          setDefaultImageDimensions={setDefaultImageDimensions}
        />
      )}
      {styledWordState.imageTool.isVisible && !isHidden ? (
        <EditImageTool
          id={id.toString()}
          uuid={uuid}
          default_uuid={default_uuid}
          imageKey={imageKey}
          editMode={editMode}
          isHidden={isHidden}
          isUploadAvailable={!isHidden}
          isEyeIconHidden={true}
          defaultImageDimensions={defaultImageDimensions}
          uploadImage={uploadImage}
        />
      ) : (
        <></>
      )}
    </WordsImageWrapper>
  );
};
